import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Registration"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.75 18.75H9.75C10.5781 18.7492 11.2492 18.0781 11.25 17.25V15H9.75V17.25H3.75V6.75H9.75V9H11.25V6.75C11.2492 5.92192 10.5781 5.25083 9.75 5.25H3.75C2.92192 5.25083 2.25083 5.92192 2.25 6.75V17.25C2.25083 18.0781 2.92192 18.7492 3.75 18.75ZM11.25 11.25H14.25V12.75H11.25V11.25ZM15.75 11.25H18.75V12.75H15.75V11.25ZM21 18.75H15C14.1721 18.7488 13.5012 18.0779 13.5 17.25V15H15V17.25H21V6.75H15V9H13.5V6.75C13.5008 5.92192 14.1719 5.25083 15 5.25H21C21.8281 5.25083 22.4992 5.92192 22.5 6.75V17.25C22.4988 18.0779 21.8279 18.7488 21 18.75ZM9 11.25H6V12.75H9V11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Registration.vue"]]);
